import type { CreateNotification201BasicInfoType } from './createNotification201BasicInfoType';

export type CreateNotification201BasicInfo = {
  /** @nullable */
  content?: string | null;
  /** @nullable */
  createdAt?: string | null;
  id: number;
  type: CreateNotification201BasicInfoType;
  /** @nullable */
  updatedAt?: string | null;
  userId: number;
};
